import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './index.module.scss';

type PaperProps = {
	styleName?: string;
	children: ReactNode;
	top?: JSX.Element;
};

export const Paper: FC<PaperProps> = ({ styleName, top, children }) => {
	const className = classNames(styles.root, styleName);

	return (
		<div className={className}>
			{top ? <div className={styles.top}>{top}</div> : ''}
			{children}
		</div>
	);
};

export default Paper;
